import { BomItemPointer } from 'model/Project/BomItemPointer'
import {
  BoMItemActivityDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemAllActivitiesSelector } from './allBomItemActivitiesSelector'

export const bomItemActivityByWorkingStepSelector =
  (
    bomItemPointer: BomItemPointer,
    workingStepType: WorkingStepType,
    /**
     * when provided, resolves the exact activity by id instead of matching
     * by working step type. This is required to correctly disambiguate
     * between multiple activities that share the same working step type
     * (e.g. two "Cleaning" activities on the same BoM item)
     */
    activityId?: string,
  ) =>
  (state: RootAppState): BoMItemActivityDto | undefined => {
    if (!bomItemPointer || (!workingStepType && !activityId)) {
      return undefined
    }

    const bomItemActivities =
      bomItemAllActivitiesSelector(bomItemPointer)(state)

    if (activityId) {
      return bomItemActivities?.find((activity) => activity.id === activityId)
    }

    const activity = bomItemActivities?.find(
      (activity) => activity.primaryWorkingStep === workingStepType,
    )

    return activity
  }
